module.exports = __webpack_public_path__ + "static/hcpettreats3-953eace3e7147fb43a105c660d4d0558.jpg";